import React, { useEffect, useState } from 'react';
import { getProjects } from '../services/api';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Card,
  CardContent,
  Typography,
  Grid,
  CardMedia,
  Button,
  Box
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTransition, animated } from '@react-spring/web';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import TruncatedText from './Truncated';
import GitHubIcon from '@mui/icons-material/GitHub';

const Root = styled('div')({
  position: 'relative',
  minHeight: '80vh',
  overflow: 'hidden',
  paddingTop: '20px',
});

const AnimatedCard = animated(Card);

const ProjectListdt = () => {
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getProjects()
      .then(response => {
        console.log('Projects data:', response.data);
        const webProjects = response.data.filter(project => project.category === "DATA_SCIENCE");
        setProjects(webProjects);
      })
      .catch(error => console.error('Error fetching projects:', error));
  }, []);

  const transitions = useTransition(projects, {
    from: { opacity: 0, transform: 'translateX(-100%)' },
    enter: { opacity: 1, transform: 'translateX(0)' },
    leave: { opacity: 0, transform: 'translateX(100%)' },
    keys: project => project.id,
  });

  const handleLinkClick = (url, event) => {
    event.preventDefault();
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleSeeMoreClick = (id) => {
    navigate(`/projects/${id}`);
  };

  return (
    <Root>
      <Container maxWidth="lg">
        <Typography variant="h3" align="center" gutterBottom>
          Web Projects
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          <TransitionGroup component={null}>
            {transitions((style, project) => (
              <CSSTransition key={project.id} timeout={300} classNames="fade">
                <Grid item xs={12} sm={6} md={4}>
                  <AnimatedCard style={{ ...style, zIndex: 1 }}>
                    {/* Wrap CardMedia in a relative Box */}
                    <Box sx={{ position: 'relative' }}>
                      <CardMedia
                        component="img"
                        height="280"
                        image={project.image}
                        alt={project.title}
                        onError={(e) => console.error('Error loading image:', e)}
                      />
                      {/* Add GitHub badge if a GitHub URL exists */}
                      {project.url && (
                      <Box
                        component="a"
                        href={project.url}  // Changed from project.url to project.github
                        onClick={(e) => handleLinkClick(project.url, e)}
                        sx={{
                          position: 'absolute',
                            // Position the icon near the bottom-right corner
                            bottom: '-16px',        // Moves the circle partly below the image
                            right: '16px',          // Adjust horizontal position
                            width: 64,
                            height: 64,
                            backgroundColor: 'background.paper',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: 1,
                            // Optional: Add a small border if you want separation from the image
                            // border: '2px solid white',
                        }}
                      >
                        <GitHubIcon sx={{ fontSize: 40 }} />
                      </Box>
                      )}
                      </Box>
                    <CardContent>
                      <Typography variant="h5" component="div">
                        {project.title}
                      </Typography>
                      <TruncatedText text={project.description} maxLength={50} />
                      <Button onClick={() => handleSeeMoreClick(project.id)}>
                        See More
                      </Button>
                    </CardContent>
                  </AnimatedCard>
                </Grid>
              </CSSTransition>
            ))}
          </TransitionGroup>
        </Grid>
      </Container>
    </Root>
  );
};

export default ProjectListdt;
